module.exports = __webpack_public_path__ + "static/grafika5-90bd70f99dbd6ffbb8e526f1d7493f42.png";